import { Button, Result, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { usePairingStore } from '../store/PairingContext';

export const FailedState = observer(() => {
  const pairingStore = usePairingStore();

  return (
    <Result
      status="error"
      title="Failed"
      subTitle="Failed to generate pairing suggestions"
      extra={[
        <Typography.Text key="error" type="secondary">
          {pairingStore.currentSelection?.type === 'pairing'
            ? pairingStore.currentSelection.pairing.error
            : pairingStore.currentSelection?.menu.pairing?.error}
        </Typography.Text>,
        <div key="actions" className="flex gap-2 mt-4 justify-center">
          <Button
            type="primary"
            onClick={pairingStore.retryPairing}
            disabled={pairingStore.isRetrying}
          >
            Retry
          </Button>
          <Button
            onClick={() => pairingStore.setPairingFormVisible(true)}
            disabled={pairingStore.isRetrying}
          >
            Edit
          </Button>
        </div>,
      ]}
    />
  );
});
